















import { Component, Vue } from 'vue-property-decorator'
import { processingLocalisationKeys } from '@/features/processing/processing.localisation'
import { JOB_LIST_NAME } from '@/features/job/job.router'
import LoaderGrid from '@/shared/loaders/LoaderGrid.component.vue'

@Component({
  components: {
    LoaderGrid
  }
})
export default class ProcessingView extends Vue {
  private translations = processingLocalisationKeys
  private nextPage: string = JOB_LIST_NAME

  private handleFinish () {
    this.$router.push({ name: this.nextPage })
  }
}
